import { Flex, PageWrapper, Spacing } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

const Loading = memo(() => {
    return (
        <PageWrapper>
            <PageWrapper.Toolbar>
                <Flex container>
                    <Flex size={4} block>
                        <Skeleton height={28} borderRadius={4} />
                    </Flex>

                    <Flex size={12} block />

                    <Flex size={8} block>
                        <Skeleton height={28} borderRadius={4} />
                    </Flex>
                </Flex>

                <Spacing height={12} />

                <Skeleton height={28} borderRadius={4} />
            </PageWrapper.Toolbar>

            <PageWrapper.Content>
                <Spacing height={20} />

                <Flex container>
                    <Flex size={5} block>
                        <Skeleton height={450} borderRadius={4} />
                    </Flex>

                    <Flex size={1} block />

                    <Flex size={5} block>
                        <Skeleton height={200} borderRadius={4} />
                    </Flex>

                    <Flex size={1} block />

                    <Flex size={5} block>
                        <Skeleton height={70} borderRadius={4} />
                    </Flex>
                </Flex>
            </PageWrapper.Content>
        </PageWrapper>
    );
});

export default Loading;
